import React from 'react';
import PropTypes from 'prop-types';

import { AvatarGroup } from '@metarouter-private/mr-mui';

import IntegrationAvatar from 'app/shared/components/integrations/IntegrationAvatar';

export default function IntegrationAvatarGroup({ integrations, max = 4, size = 'small', imgProps = {} }) {
  return (
    <AvatarGroup max={max} size={size}>
      {integrations.map(({ starterkitId, name }) => (
        <IntegrationAvatar key={name} starterkitId={starterkitId} name={name} imgProps={imgProps} />
      ))}
    </AvatarGroup>
  );
}

IntegrationAvatarGroup.propTypes = {
  integrations: PropTypes.arrayOf(
    PropTypes.shape({
      starterkitId: PropTypes.string.isRequired,
      name: PropTypes.string,
    })
  ),
  max: PropTypes.number,
  size: PropTypes.string,
  imgProps: PropTypes.object,
};
